export default __webpack_public_path__ + "static/media/lock.71d174ec.svg";